import React, { ReactElement, Component, useState, useEffect, useContext, Fragment, useMemo, useCallback } from "react";
import "./users-profile-add.less";
import { Row, Col, Button, Card, Form, Input, Tag, Select, Table } from "antd";
import { injectIntl, FormattedMessage } from "react-intl";
import { PlusOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/lib/form";
import { UserInfoContext } from "../../contexts/user-info";
import { useDeepCompareMemo } from 'use-deep-compare';
import { TweenOneGroup } from 'rc-tween-one';
import { worker_fetch } from "../../worker/worker-fetch";
import {
    isEffective,
    ROLES_LEVEL,
    format_option_data,
    parse_w_option_data,
} from "../user-management/user-util";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { parse_to_kebab } from "../user-management/user-util";

const { Option } = Select,
    COL_SPACES = 26,
    G_A = "globalAdmin",
    D_A = "datacenterAdmin",
    C_A = "clusterAdmin",
    C_O = "clusterOwner",
    cluster_admin_arr = [G_A, C_A, C_O],
    W_O = "workspaceOwner",
    N_D = "namespaceDeveloper",
    ALL_C = "All cluster",
    ALL_W = "All workspace",
    ALL_N = "All namespace";

export const UsersProfileAdd = injectIntl((props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const user_info = useContext(UserInfoContext)[0],
        datacenter_name = useContext(DatacenternameContext)[0],
        [tag_element, set_tag_element]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
        [tags, set_tags]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([]),
        [inputVisible, set_inputVisible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [inputValue, set_inputValue]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),

        [roles_data, set_roles_data]: [any[], React.Dispatch<React.SetStateAction<any[]>>] = useState<any[]>([]),
        [disable_c, set_disable_c] = useState(true),
        [disable_w, set_disable_w] = useState(true),
        [disable_n, set_disable_n] = useState(true),
        [loading_r, set_loading_r] = useState(false),
        [loading_c, set_loading_c] = useState(false),
        [loading_w, set_loading_w] = useState(false),
        [loading_n, set_loading_n] = useState(false),
        [new_role, set_new_role] = useState(""),
        [new_cluster, set_new_cluster] = useState(""),
        [new_workspace, set_new_workspace] = useState(""),
        [can_rolebinding, set_can_rolebinding] = useState(false),
        [hight_bgrole, set_hight_bgrole] = useState(""),
        [add_role_role_name, set_add_role_role_name] = useState(""),
        [add_role_cluster_name, set_add_role_cluster_name] = useState(""),
        [add_role_workspace_name, set_add_role_workspace_name] = useState(""),
        [add_role_namespace_name, set_add_role_namespace_name] = useState(""),
        [role_item, set_role_item] = useState([]),
        [all_roles_item, set_all_roles_item] = useState([]),
        [role_select, set_role_select] = useState([]),
        [cluster_item, set_cluster_item] = useState([]),
        [cluster_select, set_cluster_select] = useState([]),
        [workspaces_item, set_workspaces_item] = useState([]),
        [workspaces_select, set_workspaces_select] = useState([]),
        [namespaces_item, set_namespaces_item] = useState([]),
        [namespaces_select, set_namespaces_select] = useState([]),

        { history } = useMemo(() => props, [props]),
        { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
        [form] = Form.useForm(),
        { setFieldsValue, getFieldsValue } = useMemo((): FormInstance => form, [form]),
        get_fields_value = getFieldsValue(),

        // 添加用户方法起
        showInput = useCallback(() => {
            set_roles_data([]);
            set_inputVisible(true);
        }, []),
        handleInputChange = (e: any) => {
            set_inputValue(e.target.value)
        },
        handleInputConfirm = useCallback(() => {
            if (inputValue && tags.indexOf(inputValue) === -1) {
                const tags_1: string[] = [...tags, inputValue];
                set_tags(tags_1);
                set_inputVisible(false);
                set_inputValue('');
            } else {
                set_inputVisible(false);
                set_inputValue('');
            }
            // eslint-disable-next-line
        }, [inputValue]),
        handleClose = useCallback(
            (removedTag: any) => {
                const tags_new = tags.filter(tag => tag !== removedTag);
                set_tags(tags_new);
            }, [tags]),
        forMap = useCallback((tag) => {
            const tagElem = (
                <Tag
                    closable
                    onClose={e => {
                        e.preventDefault();
                        handleClose(tag);
                    }}
                >{tag}</Tag>
            );
            return (
                <span key={tag} style={{ display: 'inline-block' }}>
                    {tagElem}
                </span>
            );
            // eslint-disable-next-line
        }, [tags]),
        tagChild = tags.map(forMap),
        // 添加用户方法止

        roles_columns = [
            {
                title: formatMessage({ id: "name" }),
                dataIndex: "username",
            },
            {
                title: formatMessage({ id: "role" }),
                dataIndex: "roleName",
            },
            {
                title: formatMessage({ id: "cluster" }),
                dataIndex: "cluster",
                render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
            },
            {
                title: formatMessage({ id: "workspace" }),
                dataIndex: "workspaceName",
                render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
            },
            {
                title: formatMessage({ id: "namespace" }),
                dataIndex: "namespace",
                render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
            },
            {
                title: formatMessage({ id: "status" }),
                dataIndex: "status",
                render: (status: any) => (
                    status ? <Tag className="status_tag" color={status.toLowerCase() === 'success' ? '#2bc41ab5' : 'lightgray'}><span className="tag_status">{status}</span></Tag> : status
                )
            },
        ],

        handle_role_change = useCallback(
            (_value: any, option: any) => {
                const role_name = option.props.children.trim();
                set_add_role_role_name(role_name);
                set_new_role(_value);
                if (cluster_admin_arr.includes(role_name)) {
                    setFieldsValue({ cluster: undefined, workspace: ALL_W, namespace: ALL_N });
                    set_add_role_cluster_name("");
                    set_add_role_workspace_name(ALL_W);
                    set_add_role_namespace_name(ALL_N);
                    set_new_workspace("");
                    set_workspaces_item([]);
                    set_namespaces_item([]);
                    set_disable_c(false);
                    set_disable_w(true);
                    set_disable_n(true);
                } else if (role_name === D_A) {
                    setFieldsValue({ cluster: ALL_C, workspace: ALL_W, namespace: ALL_N });
                    set_new_cluster("");
                    set_add_role_cluster_name(ALL_C);
                    set_disable_c(true);
                    set_disable_w(true);
                    set_disable_n(true);
                } else if (role_name === W_O) {
                    setFieldsValue({ cluster: undefined, workspace: undefined, namespace: ALL_N });
                    set_new_cluster("");
                    set_add_role_cluster_name("");
                    set_new_workspace("");
                    set_add_role_namespace_name(ALL_N);
                    set_namespaces_item([]);
                    set_disable_c(false);
                    set_disable_n(true);
                    set_disable_w(false);
                } else {
                    setFieldsValue({ cluster: undefined, workspace: undefined, namespace: undefined });
                    set_new_cluster("");
                    set_add_role_cluster_name("");
                    set_new_workspace("");
                    set_disable_c(false);
                    set_disable_n(false);
                    set_disable_w(false);
                }
            },
            [setFieldsValue]
        ),
        handle_cluster_change = useCallback(
            (value: any, option: any) => {
                set_add_role_cluster_name(option.props.children.trim());
                set_new_cluster(value);
                if (!cluster_admin_arr.includes(add_role_role_name)) {
                    set_add_role_workspace_name("");
                    set_new_workspace("");
                    setFieldsValue({ workspace: undefined });
                    if (add_role_role_name === N_D) {
                        set_add_role_namespace_name("");
                        setFieldsValue({ namespace: undefined });
                    }
                }
            },
            [add_role_role_name, setFieldsValue]
        ),
        handle_workspace_change = useCallback(
            (value: any, option: any) => {
                const { role } = get_fields_value;
                set_add_role_workspace_name(option.props.children.trim());
                if (role !== "namespaceDeveloper") {
                    set_new_workspace(value);
                    set_add_role_namespace_name(ALL_N);
                    setFieldsValue({ namespace: ALL_N });
                } else {
                    set_new_workspace(value);
                    set_add_role_namespace_name("");
                    setFieldsValue({ namespace: undefined });
                }
            },
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [get_fields_value]
        ),
        handle_namespace_change = useCallback((_value: any, option: any) => {
            set_add_role_namespace_name(option.props.children.trim());
        }, []),

        add_role_in_page = useCallback(() => {
            (async () => {
                const { workspace } = get_fields_value;
                const new_role: any = {
                    datacenter: datacenter_name,
                    cluster: add_role_cluster_name,
                    role: parse_to_kebab(add_role_role_name),
                    workspace: workspace === ALL_W ? "" : workspace,
                    workspaceName: workspace === ALL_W ? "" : add_role_workspace_name,
                    namespace: add_role_namespace_name === ALL_N ? "" : add_role_namespace_name,
                };
                const request_list = {
                    users: tags,
                    Roles: [new_role],
                };
                if (datacenter_name && tags.length > 0) {
                    const res: any = await worker_fetch({ url: `/v1/datacenter/${datacenter_name}/muserrolebinding`, method: 1, body: request_list, props: { formatMessage, history }, datacenter_name })
                    if (res && res.data && res.data.length > 0) {
                        const add_users_new: any = [];
                        (res.data).map((item: any, index: number) => {
                            add_users_new.push({
                                key: item.user + index,
                                username: item.user,
                                status: item.status,
                                cluster: new_role.cluster,
                                roleName: new_role.role,
                                workspaceName: new_role.workspaceName,
                                namespace: new_role.namespace,
                            })
                            return add_users_new;
                        })
                        set_roles_data(add_users_new);
                    }
                    setFieldsValue({ role: undefined, cluster: undefined, workspace: undefined, namespace: undefined });
                    set_add_role_role_name("");
                    set_add_role_cluster_name("");
                    set_add_role_workspace_name("");
                    set_add_role_namespace_name("");
                    set_disable_c(true);
                    set_disable_w(true);
                    set_disable_n(true);
                    set_cluster_item([]);
                    set_workspaces_item([]);
                    set_namespaces_item([]);
                    set_new_role("");
                    set_new_cluster('');
                    set_new_workspace("");
                    set_tags([]);
                }
            })()
            // eslint-disable-next-line
        }, [
            add_role_cluster_name,
            add_role_namespace_name,
            add_role_role_name,
            add_role_workspace_name,
            datacenter_name,
            formatMessage,
            get_fields_value,
            setFieldsValue,
            tags,
        ]),

        disable_add_role_button = useMemo(() => {
            const { role, cluster, workspace, namespace } = get_fields_value;
            if (isEffective(role) && isEffective(cluster)) {
                if (cluster_admin_arr.includes(add_role_role_name)) {
                    return false;
                } else if (add_role_role_name === W_O) {
                    if (isEffective(workspace)) {
                        return false;
                    }
                } else if (add_role_role_name === N_D) {
                    if (isEffective(workspace) && isEffective(namespace)) {
                        return false;
                    }
                }
            }
            if (isEffective(role) && add_role_role_name === D_A) {
                return false;
            }
            return true;
        }, [add_role_role_name, get_fields_value]),

        parseSelect = useCallback((data: any) => {
            let children = [];
            for (let i = 0; i < data.length; i++) {
                const { key, value, text } = data[i];
                children.push(
                    <Option value={value} key={key}>
                        {` ${text}`}
                    </Option>
                );
            }
            return children;
        }, []);

    useEffect((): void => {
        const tag_element_new: JSX.Element = (
            <Fragment>
                <div>
                    <TweenOneGroup
                        enter={{
                            scale: 0.8,
                            opacity: 0,
                            type: 'from',
                            duration: 100,
                            onComplete: (e: any) => {
                                e.target.style = '';
                            },
                        }}
                        leave={{ opacity: 0, width: 0, scale: 0, duration: 200 }}
                        appear={false}
                    >
                        {tagChild}
                    </TweenOneGroup>
                </div>
                {inputVisible && (
                    <span>
                        <Input
                            autoFocus
                            type="text"
                            size="small"
                            className="mb-15"
                            style={{ width: 320, height: 30 }}
                            value={inputValue}
                            onChange={handleInputChange}
                            onBlur={handleInputConfirm}
                            onPressEnter={handleInputConfirm}
                        />
                        <span className="warning_addusers"><FormattedMessage id="please_input_username" /></span>
                    </span>
                )}
                {!inputVisible && (
                    <Tag onClick={showInput} className="site-tag-plus">
                        <PlusOutlined /> New User
                    </Tag>
                )}
            </Fragment>
        );
        set_tag_element(tag_element_new);
        // eslint-disable-next-line
    }, [inputVisible, inputValue, tags]);

    useEffect(() => {
        if (isEffective(user_info.role) && !ROLES_LEVEL[1].includes(user_info.role)) {
            set_can_rolebinding(true);
        }
    }, [user_info]);

    // 获取role的可选项
    useEffect(() => {
        if (can_rolebinding && datacenter_name) {
            const role_list = ["datacenterAdmin", "clusterAdmin", "clusterOwner", "workspaceOwner", "namespaceDeveloper"];
            set_all_roles_item((role_list as unknown) as []);
        }
    }, [datacenter_name, set_all_roles_item, can_rolebinding, history]);

    useEffect(() => {
        if (isEffective(all_roles_item) && isEffective(user_info) && datacenter_name) {
            let allow_roles: string[] = [];
            switch (hight_bgrole) {
                case "globalAdmin": allow_roles = ["globalAdmin", "datacenterAdmin", "clusterAdmin", "clusterOwner", "workspaceOwner", "namespaceDeveloper"];
                    break;
                case "datacenterAdmin": allow_roles = ["datacenterAdmin", "clusterAdmin", "clusterOwner", "workspaceOwner", "namespaceDeveloper"]
                    break;
                case "clusterAdmin": allow_roles = ["clusterAdmin", "clusterOwner", "workspaceOwner", "namespaceDeveloper"]
                    break;
                case "clusterOwner": allow_roles = ["clusterOwner", "workspaceOwner", "namespaceDeveloper"]
                    break;
                case "workspaceOwner": allow_roles = ["workspaceOwner", "namespaceDeveloper"]
                    break;
                case "namespaceDeveloper": allow_roles = ["namespaceDeveloper"]
                    break;
                default:
                    break;
            }
            set_role_item(allow_roles as any);
        } else {
            set_role_item([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hight_bgrole])

    useEffect(() => {
        set_role_select(format_option_data(role_item));
    }, [role_item]);

    // 获取当前用户可绑定的最高权限
    useEffect(() => {
        if (user_info.userName) {
            (async () => {
                set_loading_r(true);
                await worker_fetch({ url: `/v1/datacenter/${datacenter_name}/getrole`, props: { formatMessage, history }, datacenter_name }).then((res: any) => {
                    if (res && res.data) {
                        set_hight_bgrole(res.data.highBdRole);
                    }
                });
                set_loading_r(false);
            })()
        }
        // eslint-disable-next-line
    }, [user_info.userName, datacenter_name])

    // 获取cluster的可选项
    useEffect(() => {
        if (datacenter_name && user_info.userName && new_role) {
            (async () => {
                set_loading_c(true);
                new_role !== "datacenterAdmin" && await worker_fetch({
                    url: `/v1/datacenter/${datacenter_name}/getroleclusters?bindrole=${new_role}`,
                    // url: `/v1/datacenter/${datacenter_name}/clusternames`,
                    func: set_cluster_item,
                    props: { history, formatMessage, warning: false },
                    datacenter_name,
                });
                set_loading_c(false);
            })()
        }
        // eslint-disable-next-line
    }, [set_cluster_item, datacenter_name, user_info.userName, history, new_role]);
    useEffect(() => {
        set_cluster_select(parse_w_option_data(cluster_item));
    }, [cluster_item]);

    // 获取workspaces的可选项
    useEffect(() => {
        if (new_role && !cluster_admin_arr.includes(new_role) && datacenter_name && isEffective(new_cluster)) {
            (async () => {
                set_loading_w(true);
                await worker_fetch({
                    // url: `/v1/datacenter/${datacenter_name}/cluster/${new_cluster}/workspacenames`,
                    url: `/v1/datacenter/${datacenter_name}/cluster/${new_cluster}/getroleworkspaces?bindrole=${new_role}`,
                    func: set_workspaces_item,
                    props: { history, formatMessage, warning: false },
                    datacenter_name,
                });
                set_loading_w(false);
            })()
        }
        // eslint-disable-next-line
    }, [datacenter_name, set_workspaces_item, new_cluster, new_role, history]);
    useEffect(() => {
        set_workspaces_select(parse_w_option_data(workspaces_item));
    }, [workspaces_item]);

    // 获取namespaces的可选项
    useEffect(() => {
        if (datacenter_name && isEffective(new_cluster) && isEffective(new_workspace)) {
            (async () => {
                set_loading_n(true);
                new_role === "namespaceDeveloper" && worker_fetch({
                    // url: `/v1/datacenter/${datacenter_name}/cluster/${new_cluster}/workspace/${new_workspace}/namespacenames`,
                    url: `/v1/datacenter/${datacenter_name}/cluster/${new_cluster}/workspace/${new_workspace}/getrolenamespaces?bindrole=${new_role}`,
                    func: set_namespaces_item,
                    props: { history, formatMessage, warning: false },
                    datacenter_name,
                });
                set_loading_n(false);
            })()

        }
        // eslint-disable-next-line
    }, [set_namespaces_item, datacenter_name, new_cluster, new_workspace, new_role, history]);

    useEffect(() => {
        set_namespaces_select(parse_w_option_data(namespaces_item));
    }, [namespaces_item]);

    return (
        <Fragment>
            <div className="mx-20 mb-10 mt-20">
                <span className="card_title management-label-line font-size-16"><FormattedMessage id="batch_add" /></span>
            </div>
            <Card hoverable className="profile-card mx-20">
                <div>
                    {tag_element}
                </div>
                <Form form={form}>
                    <Row gutter={COL_SPACES}>
                        <Col sm={5}>
                            <Form.Item name="role" label={formatMessage({ id: "role" })} labelAlign="left" labelCol={{ sm: 24 }}>
                                <Select showSearch placeholder={formatMessage({ id: "select_role" })} optionFilterProp="children"
                                    onChange={handle_role_change} loading={loading_r}
                                >
                                    {parseSelect(role_select)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={5}>
                            <Form.Item name="cluster" label={formatMessage({ id: "cluster" })} labelAlign="left" labelCol={{ sm: 24 }}>
                                <Select
                                    showSearch
                                    placeholder={formatMessage({ id: "select_cluster" })}
                                    optionFilterProp="children"
                                    onChange={handle_cluster_change}
                                    disabled={disable_c}
                                    loading={loading_c}
                                >
                                    {parseSelect(cluster_select)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={5}>
                            <Form.Item name="workspace" label={formatMessage({ id: "workspace" })} labelAlign="left" labelCol={{ sm: 24 }}>
                                <Select
                                    showSearch
                                    placeholder={formatMessage({ id: "select_ws" })}
                                    optionFilterProp="children"
                                    onChange={handle_workspace_change}
                                    disabled={disable_w}
                                    loading={loading_w}
                                >
                                    {parseSelect(workspaces_select)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={5}>
                            <Form.Item name="namespace" label={formatMessage({ id: "namespace" })} labelAlign="left" labelCol={{ sm: 24 }}>
                                <Select
                                    showSearch
                                    placeholder={formatMessage({ id: "select_ns" })}
                                    optionFilterProp="children"
                                    onChange={handle_namespace_change}
                                    disabled={disable_n}
                                    loading={loading_n}
                                >
                                    {parseSelect(namespaces_select)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={4}>
                            <Row align="bottom" justify="center" className="mt-20">
                                <Button
                                    className="plain_button create_button"
                                    size="large"
                                    type="primary"
                                    disabled={disable_add_role_button}
                                    onClick={add_role_in_page}
                                >
                                    <PlusOutlined />
                                </Button>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="small_table management-table w-100 mt-10">
                        <Table
                            size="small"
                            className="ant-col-sm-24"
                            rowClassName={() => "font-w-5"}
                            //   rowSelection={can_rolebinding ? rowSelection.current : undefined}
                            columns={roles_columns}
                            dataSource={roles_data}
                            showSorterTooltip={false}
                        />
                    </Row>
                </Form>
            </Card>
        </Fragment>
    );
});
